export default __webpack_public_path__ + "static/media/barra_de_logos.cd91778e.png";